import $ from 'jquery';

window.showq2 = function () {
    $("#q1").hide();
    $("#q2").show();
    $("#q3").hide();
}
window.showq3 = function () {
    $("#q1").hide();
    $("#q2").hide();
    $("#q3").show();
}
$(function () {
    if ($('#corporate_apply_now').length) {
        $("#q1").show();
        $("#q2").hide();
        $("#q3").hide();
    }
});